/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Success_Account_CreatedInputs */

const en_login_success_account_created = /** @type {(inputs: Login_Success_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account created! Please check your email and verify your account before signing in.`)
};

const fr_login_success_account_created = /** @type {(inputs: Login_Success_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte créé ! Veuillez vérifier votre email et vérifier votre compte avant de vous connecter.`)
};

const de_login_success_account_created = /** @type {(inputs: Login_Success_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellt! Bitte überprüfen Sie Ihre E-Mails und bestätigen Sie Ihr Konto, bevor Sie sich anmelden.`)
};

const it_login_success_account_created = /** @type {(inputs: Login_Success_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account creato! Controlla la tua email e verifica il tuo account prima di accedere.`)
};

const ru_login_success_account_created = /** @type {(inputs: Login_Success_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учетная запись создана! Пожалуйста, проверьте свою электронную почту и подтвердите свою учетную запись перед входом.`)
};

const es_login_success_account_created = /** @type {(inputs: Login_Success_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Cuenta creada! Revisa tu correo electrónico y verifica tu cuenta antes de iniciar sesión.`)
};

const zh_cn2_login_success_account_created = /** @type {(inputs: Login_Success_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户已创建！请检查您的电子邮件并验证您的账户后再登录。`)
};

const ja_login_success_account_created = /** @type {(inputs: Login_Success_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントが作成されました。サインインする前に、メールを確認し、アカウントを確認してください。`)
};

const hi_login_success_account_created = /** @type {(inputs: Login_Success_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता बन गया! कृपया लॉग इन करने से पहले अपना ईमेल चेक करें और अपना खाता सत्यापित करें।`)
};

const pt_pt2_login_success_account_created = /** @type {(inputs: Login_Success_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta criada! Por favor, verifique seu e-mail e confirme sua conta antes de entrar.`)
};

/**
* | output |
* | --- |
* | "Account created! Please check your email and verify your account before signing in." |
*
* @param {Login_Success_Account_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_success_account_created = /** @type {((inputs?: Login_Success_Account_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Success_Account_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_success_account_created(inputs)
	if (locale === "de") return de_login_success_account_created(inputs)
	if (locale === "it") return it_login_success_account_created(inputs)
	if (locale === "ru") return ru_login_success_account_created(inputs)
	if (locale === "es") return es_login_success_account_created(inputs)
	if (locale === "zh-CN") return zh_cn2_login_success_account_created(inputs)
	if (locale === "ja") return ja_login_success_account_created(inputs)
	if (locale === "hi") return hi_login_success_account_created(inputs)
	if (locale === "pt-PT") return pt_pt2_login_success_account_created(inputs)
	return en_login_success_account_created(inputs)
});